import log from "loglevel";
import { TBaseQuery } from "../../../../models/baseQueries/baseQuery";

export const baseQueryWithZodValidation: (baseQuery: TBaseQuery) => TBaseQuery =
  (baseQuery: TBaseQuery) => async (args, api, extraOptions) => {
    const returnValue = await baseQuery(args, api, extraOptions);

    const zodSchema = extraOptions?.dataSchema;

    const { data } = returnValue;

    if (data && zodSchema) {
      const result = zodSchema.safeParse(data);
      if (!result.success) {
        log.error(result.error.format());
      }
    }

    return returnValue;
  };
